import cx from 'classnames';
import { FC } from 'react';
import Analytics from './Assets/Analytics.svg?url';
import AppLauncher from './Assets/AppLauncher.svg?url';
import Calendar from './Assets/Calendar.svg?url';
import Doctor from './Assets/Doctor.svg?url';
import Filter from './Assets/Filter.svg?url';
import HappyFace from './Assets/HappyFace.svg?url';
import Heart from './Assets/Heart.svg?url';
import Home from './Assets/Home.svg?url';
import Menu from './Assets/Menu.svg?url';
import Sales from './Assets/Sales.svg?url';
import ScientificInformation from './Assets/ScientificInformation.svg?url';
import Search from './Assets/Search.svg?url';
import styles from './CesNavigationIcon.module.css';

const assets = {
  Analytics,
  AppLauncher,
  Calendar,
  Doctor,
  Filter,
  HappyFace,
  Heart,
  Home,
  Menu,
  Sales,
  ScientificInformation,
  Search,
};
export type CesNavigationIconName = keyof typeof assets;
export interface CesNavigationIconProps {
  name: CesNavigationIconName;
  active?: boolean;
}

const CesNavigationIcon: FC<CesNavigationIconProps> = ({ name, active = false }) => (
  <span
    className={cx(styles.icon, (active || ['Menu', 'Calendar', 'Filter'].includes(name)) && styles.brand)}
    style={{ maskImage: `url("${assets[name]}")` }}
    aria-hidden="true"
  />
);
export default CesNavigationIcon;
